import { useEffect, useState } from "react";
import axios from "axios";
import { APIURL } from "../..";
import { Link } from "react-router-dom";
import Loading from "../UI/Loading";
import Lokalita from "../UI/Lokalita";

const Lokality = () => {
    const [lokalityData, setLokalityData] = useState({}); 
    const [loading, setLoading] = useState(true); 
    const getLokality = async () => {
        await axios
            .post(APIURL + "/collection/items", {
                type: 'tried',
                orderAsc: "ASC", 
                limit: 10, 
                page: 1,
                language: 'cs',
                filter:[ 
                    {name:"alt", value:"omv"},
                    {name:"alt", value:"oalib"},
                    {name:"alt", value:"mkej"},
                    {name:"alt", value:"frumos"},
                    {name:"alt", value:"clovicek"},
                    {name:"alt", value:"dual"},
                    {name:"alt", value:"loreal"},
                    {name:"alt", value:"rychvald"},
                    {name:"alt", value:"telos"},
                    {name:"alt", value:"afry"}
                ], 
            })
            .then((response) => { 
                setLokalityData(response.data.body);
                setLoading(false)
            });
    };

    useEffect(() => {
        getLokality();
    }, []);
    return (
        <>
            <section className="lokality" id="lokality">
                <div className="lokality__box">
                    <div className="perex">
                        <span>Navštívili jsme</span>
                        <h2>Kde všude jsme byli?</h2>
                        <p> Jako putovní projekt navštěvujeme veřejné i soukromé akce. Pořádáme školení pro firmy, návštěvy v autoškolách a akce pro základní a střední školy. Místa a společnosti, které jsme již navštívili, můžete vidět níže. </p>
                    </div> 

                    {loading ? (
                        <div style={{margin:"2rem"}}>
                            <Loading />
                        </div>
                    ) : (
                        <div className="firmy">
                            {lokalityData?.items?.map((lokalita, i) => (
                                <Lokalita lokalita={lokalita}/>
                            ))}
                        </div>
                    )}      
                    <a
                        href="https://en.mapy.cz/s/fepegezumu"
                        className="button transBlue"
                        target="_blank"
                        style={{ margin: "auto" }}
                        rel="noopener noreferrer"
                    >
                        mapa navštívených míst
                    </a> 
                    <Link
                        to="/lokality"
                        className="button transBlue"
                        style={{ margin: "auto", marginTop:"1rem" }}
                    >
                        další lokality
                    </Link>  
                </div>
            </section>
        </>
    );
};

export default Lokality;
